import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { fetchMarketDetails, setCompareMarket, setComparisonMarketSelected } from '../../actions';
import '../../css/MarketCompare.scss';
import { Col, Collapse, NavItem } from 'reactstrap';
import rightArrow from '../../images/right-arrow-head.svg';
import expandIcon from '../../images/expand-arrow.svg';
import collapseIcon from '../../images/collapse-arrow.svg';


export class CompareMarketsListMobile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showRegion: {},
    }
  }

  toggleRegion = (index) => {
    this.setState((prevState) => {
      const showRegion = { ...prevState.showRegion }
      showRegion[index] = !showRegion[index]
      return {
        showRegion: showRegion
      }
    })
  }

  componentDidUpdate(prevProps) {
    if( (this.props.marketCompareQuarters.length  != 0) && (prevProps.marketCompareQuarters !== this.props.marketCompareQuarters)) {

      this.props.history.push(this.props.basepath + '/marketcomparisonmobile?market=' + this.props.leftpanelmarketselected + '&comparemarket='+ this.props.comparemarketselected)
      
    }
    if (prevProps.markets !== this.props.markets) {
      const market = this.getMarket()
      const showRegion = {}
      const length = Object.keys(market).length
      for (let index = 0; index < length; index++) {
        showRegion[index] = index === 0

      }
      this.setState({ showRegion: showRegion })
    }
  }

  OnMarketClick = (market) => {
    this.props.setCompareMarket(market);
    this.props.getDetailCompare('FETCH_COMPARE_MARKET_DETAILS',market);
  //  this.fetchMarketInfo(market);
  }

  fetchMarketInfo(market) {
    market = market.trim()
    let region = ''
    let greaterRegion = ''

    this.props.markets.find((x) => {
      if (x.market === market) {
        region = x.region
        greaterRegion = x.greaterRegion
      }
      return null;
    })

    this.props.setComparisonMarketSelected({ greaterRegion, region, market });
  }


  getMarket = () => {

    let market = null;
    if (this.props.comparegreaterregion === "Global") {

      let displayOrder = ["Americas", "Europe", "Asia Pacific"];
      market = this.props.markets.reduce((marketsSoFar, { greaterRegion, market }) => {
        for (let i = 0; i < displayOrder.length; i++) {
          if (!marketsSoFar[displayOrder[i]]) marketsSoFar[displayOrder[i]] = [];
          if (displayOrder[i] === greaterRegion)
            marketsSoFar[greaterRegion].push(market);
        }
        return marketsSoFar;
      }, {});

    }
    else {
      market = this.props.markets.reduce((marketsSoFar, { region, market }) => {
        if (!marketsSoFar[region]) marketsSoFar[region] = [];
        marketsSoFar[region].push(market);
        return marketsSoFar;
      }, {});

    }
    return market
  }

  render() {
    const market = this.getMarket()
    return (
      <div className="mobile-add-comparison-container main-container">
        <div>
          {
            Object.keys(market).map((region, index) => {
              let count = 0
              let eachRegionMarketsLength = market[region].length
              return (
                <div key={index}>
                  <NavItem className="compare-selection-header accordian-header" onClick={() => this.toggleRegion(index)}>
                    <div className="accordian-header-text">
                      {region.replace('U.S.', 'United States').replace('CANADA', 'Canada').replace('LATIN AMERICA', 'Latin America')}
                    </div>
                    <div className="accordian-toggle">
                      <img className="accordian-icon" alt="accordian" src={this.state.showRegion[index] ? 
                        '#{rentrackerappimages}#' + '/collapse-arrow.svg' : 
                        '#{rentrackerappimages}#' + '/expand-arrow.svg'} />
                    </div>
                  </NavItem>
                  <Collapse isOpen={this.state.showRegion[index]}>
                    <div className="market-table-body" >
                      {
                        market[region].sort().map((mrkt, regionIndex) => {
                          const a = regionIndex - count
                          let lastRow = false
                          if (eachRegionMarketsLength % 2 === 0) {
                            lastRow = a === eachRegionMarketsLength - 1 || a === eachRegionMarketsLength - 2
                          } else {
                            lastRow = a === eachRegionMarketsLength - 1
                          }
                          return  <Col xs={6} className="each-market-col-compare" key={regionIndex} style={{ }} onClick={() => this.OnMarketClick(mrkt)}>
                            <div className="market-table-cell-mobile-compare" >
                            {mrkt}
                          <img id="right-arrow-symbol" alt="right-arrow" src={'#{rentrackerappimages}#' + '/right-arrow-head.svg'} onClick={() => this.OnMarketClick(mrkt)}/></div>
                          </Col>
                        })
                      }
                    </div>
                  </Collapse>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    comparegreaterregion: state.comparegreaterregion,
    leftpanelmarketselected:state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : [],
    basepath: state.basepath,
    marketCompareQuarters: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].marketDetails : [],
    comparemarketselected: state.comparemarketselected
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDetailCompare: (actionType,compareval) => {
      dispatch(fetchMarketDetails(actionType,compareval))
    },
    setCompareMarket: (market) => {
      dispatch(setCompareMarket(market))
    },
    setComparisonMarketSelected: (selection) => {
      dispatch(setComparisonMarketSelected(selection))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompareMarketsListMobile));
